/**
 * Maximum number of items submenu can have, after which overflow: 'auto' will be applied to it
 */
export const MAX_SUBMENU_SIZE: number = 10

/**
 * Maximum menu height in pixels
 */
export const MAX_MENU_HEIGHT: string = '530px'

export enum OVERFLOW_VALUES {
    AUTO = 'auto',
    INITIAL = 'initial',
}
